module.exports = {"520424002":"顶云街道","520424003":"关索街道","520424004":"龙潭街道","520424102":"永宁镇","520424103":"岗乌镇","520424104":"上关镇","520424105":"坡贡镇","520424107":"白水镇","520424108":"新铺镇","520424109":"沙营镇","520424110":"花江镇","520424111":"断桥镇","520424202":"普利乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520424.json
// module id = 2481
// module chunks = 0